import type { ThemeState } from '@atlaskit/tokens/theme-config';
import { themeStringToObject } from '@atlaskit/tokens/theme-state-transformer';

import { updateThemeObjectWithDefaultValues } from './update-theme-object-with-default-values';
export const updateThemeWithDefaultValues = (themeString: string): Partial<ThemeState> =>
	updateThemeObjectWithDefaultValues(themeStringToObject(themeString));

export { updateThemeObjectWithDefaultValues } from './update-theme-object-with-default-values';
